import { render, staticRenderFns } from "./DashboardComponentOld.vue?vue&type=template&id=29232001&scoped=true"
import script from "./DashboardComponentOld.vue?vue&type=script&lang=js"
export * from "./DashboardComponentOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29232001",
  null
  
)

export default component.exports